import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g>
    <rect
      x="1.5"
      y="1.5"
      width="17"
      height="17"
      rx="3.5"
      stroke={fill}
      transform="translate(2 2)"
    />
  </g>
);

export default Icon;
